export default __webpack_public_path__ + "static/media/13.1ecb1b89.jpg";